interface SpinnerProps {
  size?: 'sm' | 'md'
  className?: string
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
}

export const Spinner = ({ size = 'md', className = '' }: SpinnerProps) => (
  <div className={`border-2 border-primary-400 border-t-transparent animate-spin ${sizeClasses[size]} ${className}`} />
)
